export const APP_STATUS = {
  firstInstalled: 'firstInstalled', // 会員未登録
  accountCreated: 'accountCreated', // 会員登録済み経歴未登録
  userInformationRegistered: 'userInformationRegistered', // 経歴登録済価値観未回答
  personalValueQuestionAnswered: 'personalValueQuestionAnswered' // 価値観回答とシナリオシミュレーション完了
} as const;
